import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Types of Manufacturing Software Solutions Do You Offer?",
      a: "We offer comprehensive manufacturing software solutions tailored to meet various needs, including production planning, inventory management, quality control, and more.",
    },
    {
      q: "How Can Your Software Enhance Production Efficiency?",
      a: "Our software optimizes production workflows, automates routine tasks, and provides real-time insights to streamline processes and boost overall efficiency.",
    },
    {
      q: "Is Your Manufacturing Software Customizable to Our Specific Production Processes?",
      a: "Absolutely. Our solutions are highly customizable to align with the unique requirements of your manufacturing processes, ensuring a seamless fit.",
    },
    {
      q: "How Does Your Software Support Inventory Management for Manufacturers?",
      a: "Our software facilitates real-time tracking, automated reordering, and efficient management of inventory levels to prevent stockouts or overstock situations.",
    },
    {
      q: "Can Your Software Help With Quality Control and Assurance?",
      a: "Yes, our software includes features for implementing quality checks at various production stages, tracking defects, and ensuring adherence to quality standards.",
    },
    {
      q: "How Does Your Software Assist in Supply Chain Management for Manufacturers?",
      a: "Our software streamlines procurement, manages supplier relationships, and optimizes the entire supply chain to reduce lead times and enhance collaboration.",
    },
    {
      q: "Is Real-time Data Analytics a Feature of Your Manufacturing Software?",
      a: "Absolutely. Our software includes robust data analytics tools to provide real-time insights into production performance, identify trends, and support informed decision-making.",
    },
    {
      q: "Can Your Software Integrate With Other Systems, Such as Erp Systems?",
      a: "Yes, our software is designed for seamless integration with various systems, including ERP solutions, to provide a unified view of business operations.",
    },
    {
      q: "How Do You Ensure Regulatory Compliance With Your Manufacturing Software?",
      a: "Our software includes features to monitor and ensure compliance with industry regulations and standards relevant to product manufacturing.",
    },
    {
      q: "What Support and Maintenance Services Do You Offer After the Software Implementation?",
      a: "We provide ongoing support, regular updates, and maintenance services to ensure the continued efficiency and reliability of our manufacturing software.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
